<template>
    <v-container fluid class="bg-main">
        <v-layout row>
            <v-flex xs12>

                <v-card>
                    <v-card-title>
                        Nhật ký Vip:
                        <v-spacer></v-spacer>

                        <div class="float-right div-icon-action">
                            <v-icon @click="print" >mdi-printer</v-icon>
                        </div>
                        <div class="float-right div-icon-action ml-0">
                            <export-excel  :data   = "desserts">
                                <v-icon>mdi-file-export</v-icon>
                            </export-excel>
                        </div>
                    </v-card-title>
                    <div id="fb-post-activity-log">
                        <v-data-table
                                :headers="headers"
                                :items="desserts"
                                :options.sync="options"
                                :server-items-length="totalDesserts"
                                :loading="loading"
                                class="elevation-1"
                        >
                            <template v-slot:item.uid = "{item}">
                                <v-layout row>
                                    <a class="a-post-link" :href="item.link_uid" target="_blank">{{ item.uid }}</a>
                                </v-layout>
                            </template>
                            <template v-slot:item.post_id = "{item}">
                                <v-layout row>
                                    <a class="a-post-link" :href="item.post_link" target="_blank">{{ item.post_id }}</a>
                                </v-layout>
                            </template>

                        </v-data-table>
                    </div>

                    <div id="fb-post-activity-log-print">
                        <v-data-table
                                :headers="headers"
                                :items="desserts"
                                :options.sync="options"
                                :server-items-length="totalDesserts"
                                :loading="loading"
                                class="elevation-1"
                                disable-pagination
                                hide-default-footer
                        >

                        </v-data-table>
                    </div>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    // import {fbPostOrderList} from "../../store/data.sample";
    import {
        FB_POST_GET_LIST_REACTION,
        FB_POST_GET_LIST_SEEDING,
        VIP_FACE_LOG
    } from "../../store/actions.type";
    import Swal from 'sweetalert2';

    export default {
        data () {
            return {
                dialog: false,
                search:'',
                totalDesserts: 0,
                desserts: [],
                loading: true,
                options: {},
                headers: [
                    { text: '#', value: 'id', align: "center"},
                    { text: 'Username', value: 'username', align: "center", width:"170px"},
                    { text: 'Uid', value: 'uid'},
                    { text: 'Object Id', value: 'post_id', align: "center" },
                    { text: 'Loại', value: 'reaction_name', align: "center"  },
                    { text: 'Khởi tạo  ', value: 'time_create', align: "center"  },
                ],
                listSeedingApi: [],
                listReaction: []
            }
        },
        props: {
            seeding_type: Number,
        },
        watch: {
            options: {
                handler () {
                    this.getDataFromApi()
                        .then(data => {
                            this.desserts = data.items
                            this.totalDesserts = data.total
                        })
                },
                deep: true,
            },

            search() {
                this.getDataFromApi()
                    .then(data => {
                        this.desserts = data.items,
                            this.totalDesserts = data.total
                    });

            }
        },
        mounted () {
            this.getDataFromApi()
                .then(data => {
                    this.desserts = data.items,
                        this.totalDesserts = data.total
                });
        },
        methods: {
            async getDataFromApi () {
                this.listSeedingApi =  await this.$store.dispatch(FB_POST_GET_LIST_SEEDING);
                this.listReaction = await this.$store.dispatch(FB_POST_GET_LIST_REACTION);

                this.loading = true
                const { sortBy, sortDesc, page, itemsPerPage } = this.options
                console.log('a'+ this.seeding_type);
                let items =  await this.$store.dispatch(VIP_FACE_LOG, {"seeding_type": this.seeding_type });
                const total = items.length

                if (sortBy.length === 1 && sortDesc.length === 1) {
                    items = items.sort((a, b) => {
                        const sortA = a[sortBy[0]]
                        const sortB = b[sortBy[0]]

                        if (sortDesc[0]) {
                            if (sortA < sortB) return 1
                            if (sortA > sortB) return -1
                            return 0
                        } else {
                            if (sortA < sortB) return -1
                            if (sortA > sortB) return 1
                            return 0
                        }
                    })
                }

                if (itemsPerPage > 0) {
                    items = items.slice((page - 1) * itemsPerPage, page * itemsPerPage)
                }
                this.loading = false;
                return {items,total};

            },
            print() {
                this.$htmlToPaper("fb-post-activity-log-print");
            },
            showInfo(item){
                let cm = JSON.parse(item.comment_need);
                // alert("a\na");
                Swal.fire({
                    title: "Các bình luận đã đăng ký",
                    html: cm.join("<br>")
                });
            }
        },
    }
</script>
<style lang="scss">
    .div-icon-action{
        i {
            cursor: pointer;
        }
    }
    .a-post-link {
        text-decoration: none;
    }
    #fb-post-activity-log-print {
        display: none;
    }
</style>
